import React, { Fragment } from 'react'
import Component from 'components/component'
import { NavLink, Route, Switch, withRouter } from 'react-router-dom'
import { Link } from 'components/link'
import { matchPath } from 'react-router'
import { DI } from 'modules'

import HeaderProfile from './header-profile'
import HeaderMobileMenu from './header-mobile-menu'
import HeaderSearch from './header-search'
import Newsletter from './newsletter'
import LinkA from './link-a'
import RuptlyLogo from './logo'
import RuptlyLogoEn from './logo-en'
import IconProfile from './icons/icon-profile'
import IconLogin from './icons/icon-login'
import {
  dashboard,
  landingDashboard,
  livesList,
  livesView,
  myEventsList,
  signin,
  signup,
  videosFilter,
  videosList,
  videoView,
} from 'config/routes'
import { isProd, PRJ_ENV, IS_LANDING, ruLocaleOnly } from 'config'

const { component, getPath, ...dashboardRoute } = dashboard

const Empty = () => null

export class HeaderMain extends Component {
  constructor(props) {
    super(props)
    this.node = React.createRef()
  }

  static defaultProps = {
    openSignInModal() {},
  }

  items = []

  state = {
    selectedEvent: null,
    reducedMenu: {
      inited: false,
      main: [],
      dots: [],
    },
    dotsPosition: 0,
  }

  componentDidMount() {
    if (!ruLocaleOnly) {
      setTimeout(() => {
        this.reduceMenu()
      }, 500)
      window.addEventListener('resize', this.reduceMenu)
    }

    if (this.props.onChangeFixed) {
      this.setFloatFixed()
      window.addEventListener('resize', this.setFloatFixed)
      window.addEventListener('scroll', this.setFloatFixed)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setFloatFixed)
    window.removeEventListener('scroll', this.setFloatFixed)

    if (!ruLocaleOnly) {
      window.clearTimeout(this.reduceTimeout)
      window.removeEventListener('resize', this.reduceMenu)
    }
  }

  string = key => this.props.common.strings[key]

  get isReverse() {
    return this.props.common.locale === 'ar'
  }

  setFloatFixed = () => {
    const floatFixed =
      window.scrollY && window.scrollY >= this.node.current.offsetTop

    this.props.onChangeFixed(floatFixed)
  }

  reduceMenu = () => {
    if (this.menu && window && this.items.length > 0) {
      const menuRect = this.menu.getBoundingClientRect()
      const items = this.isReverse ? this.items.reverse() : this.items
      let dotsPosition = 0

      let reducedMenu = items.reduce(
        (result, item, index) => {
          if (item) {
            const itemRect = item.getBoundingClientRect()
            const dotsWidth = items.length - 1 === index ? 0 : 47
            const counter = this.isReverse ? items.length - 1 - index : index

            function distributor(isDots) {
              if (isDots) {
                result.dots.push(counter)
              } else {
                result.main.push(counter)
              }
            }

            if (this.isReverse) {
              distributor(itemRect.left + dotsWidth < menuRect.left)
            } else {
              distributor(
                itemRect.left + itemRect.width + dotsWidth >
                  menuRect.left + menuRect.width
              )
            }
          }
          return result
        },
        {
          inited: true,
          main: [],
          dots: [],
        }
      )

      if (reducedMenu.dots.length > 0) {
        const currHiddenNodeIndex = this.isReverse
          ? items.length - reducedMenu.dots.length
          : reducedMenu.dots[0]

        const protoEl = (this.isReverse ? [...items].reverse() : items)[
          currHiddenNodeIndex
        ]
        if (protoEl) {
          const protoPos = protoEl.getBoundingClientRect()
          dotsPosition =
            protoPos[this.isReverse ? 'right' : 'left'] - menuRect.left

          if (this.isReverse) {
            const itemStyle = window.getComputedStyle(protoEl)
            const intent = parseInt(itemStyle.getPropertyValue('margin-right'))

            dotsPosition -= intent / 2
          }
        }
      }

      this.setState({ reducedMenu, dotsPosition })
    }
  }

  toggleMobileMenu = ev => {
    ev.preventDefault()
    this.props.actions.common.toggleMobileMenu()
  }

  closeNewsletterModal = ev => {
    ev && ev.preventDefault()
    this.props.actions.common.closeNewsletterModal()
  }

  toggleInternationalMix = ev => {
    ev.preventDefault()
    const { with_international_mix, ...params } = this.props.common.searchParams || {}
    const value = !with_international_mix
    const { location, actions } = this.props
    const isRelevantPage =
      matchPath(location.pathname, videosList) ||
      matchPath(location.pathname, dashboard) ||
      matchPath(location.pathname, videosFilter) ||
      matchPath(location.pathname, landingDashboard)

    if (value) {
      params.with_international_mix = true
    } else {
      delete params.with_international_mix
    }

    actions.common.updateSearchParams(
      params,
      true,
      isRelevantPage ? location.pathname : `/${this.props.common.locale}`
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (!ruLocaleOnly && prevProps.common.locale !== this.props.common.locale) {
      setTimeout(() => {
        this.reduceMenu()
      }, 500)
    }
  }

  _renderDots() {
    if (this.state.reducedMenu.dots.length === 0) {
      return null
    }
    return (
      <div
        style={{
          position: 'absolute',
          left: this.state.dotsPosition,
          top: 2,
          marginLeft: 0,
        }}
      >
        <a
          href="#"
          className="menu__link menu__link--more"
          onClick={e => {
            e.preventDefault()
            this.setState({ menuMoreOpen: true })
          }}
          onBlur={() => {
            this.setState({ menuMoreOpen: false })
          }}
        >
          <span className="menu-more" />
        </a>
        <div
          className="menu-submenu"
          style={{
            opacity: this.state.menuMoreOpen ? '1' : '0',
            visibility: this.state.menuMoreOpen ? 'visible' : 'hidden',
          }}
        >
          <ul className="menu-submenu__list">
            {this.props.menu.mainMenu
              .filter((_, index) => this.state.reducedMenu.dots.includes(index))
              .map(subitem => (
                <li key={subitem.link} className="menu-submenu__item">
                  <LinkA
                    link={subitem.link}
                    external={subitem.external}
                    className={this.classList(
                      'menu-submenu__link',
                      subitem.active && '_active'
                    )}
                  >
                    {subitem.title}
                  </LinkA>
                </li>
              ))}
          </ul>
        </div>
      </div>
    )
  }

  render() {
    const isSignedIn = this.props.user.isSignedIn
    const { strings, locale, newsletterModal, searchParams } =
      this.props.common
    const { with_international_mix: mix } = this.props.common.searchParams || {}
    const search = mix ? `?with_international_mix=${mix}` : ''
    const user = this.props.user.currentUser.payload
    const isClientSupervisor = user?.admin_group === 'client_supervisor'
    const showInternationalMixToggle =
      !isClientSupervisor &&
      (matchPath(this.props.location.pathname, videosList) ||
        matchPath(this.props.location.pathname, dashboard) ||
        matchPath(this.props.location.pathname, videosFilter) ||
        matchPath(this.props.location.pathname, landingDashboard))

    return (
      <Fragment>
        <div className="header-main header-main--new" ref={this.node}>
          <div className="iwrap">
            <div className="header-inner header-inner--new">
              <Link to={'/' + search} className="header-logo header-logo--new">
                {ruLocaleOnly
                  ? <RuptlyLogo className="header-logo__svg" />
                  : <RuptlyLogoEn className="header-logo__svg" />
                }
                {!isProd && <span className="header-logo__env">{PRJ_ENV}</span>}
              </Link>

              {!IS_LANDING && (
                <nav className="header-nav">
                  <ul className="header-nav__list">
                    {this.props.menu.mainMenu
                      .filter(item => item.title)
                      .map((item, index) => (
                        <li key={item.link} className="header-nav__item">
                          <LinkA
                            link={item.link}
                            external={item.external}
                            searchParams={searchParams}
                            className={this.classList(
                              'header-nav__link',
                              item.active && '_active'
                            )}
                          >
                            {item.title}
                          </LinkA>
                          {Boolean(
                            item.children.length &&
                            item.children.filter(item => item.title).length >
                            1
                          ) && (
                            <div className="header-nav__submenu">
                              <ul className="header-nav__submenu-list">
                                {item.children
                                  .filter(subitem => subitem.title)
                                  .map(subitem => (
                                    <li
                                      key={subitem.link}
                                      className="header-nav__submenu-item"
                                    >
                                      <LinkA
                                        link={subitem.link}
                                        external={subitem.external}
                                        searchparams={searchParams}
                                        className={this.classList(
                                          'header-nav__submenu-link',
                                          subitem.active && '_active'
                                        )}
                                      >
                                        {subitem.title}
                                      </LinkA>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          )}
                        </li>
                      ))}
                  </ul>
                </nav>
              )}

              {showInternationalMixToggle && (
                <button
                  type="button"
                  className={this.classList(
                    'header-mix-toggle',
                    mix && '_active'
                  )}
                  onClick={this.toggleInternationalMix}
                  title={strings['mixed_content.tooltip']}
                >
                  <span className="header-mix-toggle__track">
                    <span className="header-mix-toggle__thumb" />
                  </span>
                  <span className="header-mix-toggle__label">
                    {ruLocaleOnly
                      ? 'Англоязычные новости'
                      : 'Russian news feed'
                    }
                  </span>
                </button>
              )}

              <div className="header-actions">
                <Switch>
                  <Route {...dashboard} component={Empty} />
                  <Route {...videosList} component={Empty} />
                  <Route {...livesList} component={Empty} />
                  <Route {...videoView} component={Empty} />
                  <Route {...livesView} component={Empty} />
                  <Route {...myEventsList} component={Empty} />
                  <Route {...videosFilter} component={Empty} />
                  {isSignedIn && <Route component={HeaderSearch} />}
                </Switch>

                {isSignedIn ? (
                  <div className="header-user">
                    <NavLink
                      to={`/${locale}/user`}
                      className="header-user__btn"
                      activeClassName="_active"
                    >
                      <IconProfile className="header-user__icon" />
                      <span className="header-user__name">
                        {user.first_name && user.last_name
                          ? `${user.first_name} ${user.last_name.charAt(0)}.`
                          : strings['header.profile.signedin']}
                      </span>
                    </NavLink>
                    <HeaderProfile />
                  </div>
                ) : (
                  <Fragment>
                    {IS_LANDING ? (
                      <a
                        href="#"
                        className="header-signin-btn header-signin-btn--signup"
                        onClick={this.props.openSignUpModal}
                        data-action-name="header button"
                      >
                        {strings['header.profile.signup']}
                      </a>
                    ) : (
                      <Link
                        to={signup.getPath()}
                        className="header-signin-btn header-signin-btn--signup"
                        data-action-name="header button"
                      >
                        {strings['header.profile.signup']}
                      </Link>
                    )}
                    {IS_LANDING ? (
                      <a
                        href="#"
                        className="header-signin-btn"
                        onClick={this.props.openSignInModal}
                        data-action-name="header button"
                      >
                        <IconLogin className="header-signin-btn__icon" />
                        {this.string('header.profile.signin') ||
                          'Войти'}
                      </a>
                    ) : (
                      <Link
                        to={signin.getPath()}
                        className="header-signin-btn"
                        data-action-name="header button"
                      >
                        <IconLogin className="header-signin-btn__icon" />
                        {this.string('header.profile.signin') ||
                          'Войти'}
                      </Link>
                    )}
                  </Fragment>
                )}
              </div>

              <button
                type="button"
                className={this.classList(
                  'header-burger',
                  this.props.common.mobileMenuOpen && '_opened'
                )}
                onClick={this.toggleMobileMenu}
              >
                <span className="header-burger__line" />
                <span className="header-burger__line" />
                <span className="header-burger__line" />
              </button>
            </div>
          </div>
        </div>
        <HeaderMobileMenu
          openSignInModal={this.props.openSignInModal}
          openSignUpModal={this.props.openSignUpModal}
          showInternationalMixToggle={showInternationalMixToggle}
          onToggleInternationalMix={this.toggleInternationalMix}
          internationalMixActive={mix}
          strings={strings}
        />

        {newsletterModal && (
          <Newsletter
            onClose={this.closeNewsletterModal}
            openNewsletterModal={this.closeNewsletterModal}
          />
        )}
      </Fragment>
    )
  }
}

export default withRouter(DI(['user', 'menu'])(HeaderMain))
